export const getUserInitials = (userFullName: string) => {
  if (!userFullName) return "";

  const initial = userFullName?.[0];
  const lastName = userFullName.split(" ").slice(-1)[0];
  return lastName != userFullName ? initial + lastName?.[0] : initial;
};
